import styled from "@emotion/styled";
import React from "react";
import {  keyframes } from "@emotion/core";
import "date-fns";
import 'react-tippy/dist/tippy.css';
import Flex from "./UI-Components/Flex";
import MyCampo from "./UI-Components/Campo";
import {Elastic} from "./UI-Components/Flex/styles";
import Mycard from "./UI-Components/Card";
import {BtnTab} from "./UI-Components/Btn";

export {
    Flex,
    MyCampo,
    Elastic,
    Mycard,
    BtnTab
}



export const Transition = keyframes`
    from{
     opacity:0; 
     transform:scale(1.1);
    }
    to{
    opacity:1;
    transform:scale(1);
    }
`;
export const colors = {
    title: "#8898AA",
    bgg: "#F4F5F7",
    label: "#525F7F",
    btn: "#40A8E6",
    btnH: "#0F85CB",
    black: "#000",
    alertG: "#67C940",
    alertR: "#E1251B",
    alertY: "#FFD100",
    naranja: "#F55806",
};



export const ContenedorMain = styled(Flex)`
  background-color : ${props => props.bgColor ? props.bgColor : colors.naranja};
  font-family: 'Roboto', sans-serif;
  width      : 100%;
  height     : auto;
  min-height : 100%;
  overflow   : hidden;
  overflow-y : auto;

  @media all and (min-height:668px){
      height:100%;
  }
`;







